import { getResponseJson } from '../../../services/getresponsejson.js';

function createClientReviewSearchService(serviceRoutes) {
  const searchReviews = searchConfiguration => {
    return fetch(serviceRoutes.searchReviews, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      method: 'POST',
      credentials: 'include',
      body: JSON.stringify(searchConfiguration)
    })
    .then(getResponseJson);
  };

  return {
    searchReviews,
    serviceRoutes
  };
}

export { createClientReviewSearchService };
